import { cn } from '@/lib/utils';

export function Card({ children, className = '' }: { children?: React.ReactNode; className?: string }) {
  return <div className={cn('rounded-lg border bg-white dark:bg-gray-800 shadow-sm', className)}>{children}</div>;
}

export function CardHeader({ children, className = '' }: { children?: React.ReactNode; className?: string }) {
  return <div className={cn('flex flex-col space-y-1.5 p-6', className)}>{children}</div>;
}

export function CardTitle({ children, className = '' }: { children?: React.ReactNode; className?: string }) {
  return <h3 className={cn('text-lg font-semibold leading-none tracking-tight', className)}>{children}</h3>;
}

export function CardContent({ children, className = '' }: { children?: React.ReactNode; className?: string }) {
  return <div className={cn('p-6 pt-0', className)}>{children}</div>;
}

export function CardFooter({ children, className = '' }: { children?: React.ReactNode; className?: string }) {
  return <div className={cn('flex items-center p-6 pt-0', className)}>{children}</div>;
}

export function CardDescription({ children, className = '' }: { children?: React.ReactNode; className?: string }) {
  return <p className={cn('text-sm text-gray-500', className)}>{children}</p>;
}
